import React, { useEffect, useState } from "react";
import { ListItemText, Grid, Divider } from "@mui/material";
import User from "../../types/User";
import UserAutocomplete from "../Shared/UserAutocomplete";
import SplitRow from "../Shared/SplitRow";
import { StateLabel, StateButton } from "./Buttons";
import { ChangeProps } from "../Lessons/Show";
import Api from "../../network/Api";
import { SolutionState } from "../../types/Solutions";
import Actions, { ActionProps } from "./Actions";
import dayjs from "dayjs";

const Toolbar = (props: ChangeProps & ActionProps) => {

  const usersSelectable = props.solution && SolutionState[props.solution.state] !== SolutionState.resolved;
  const [users, setUsers] = useState<Array<User>>([]);

  useEffect(() => {
    Api.get(`/users`).then(setUsers);
  }, []);

  return <>
    <Grid container spacing={2}>
    { props.solution && <>
      <SplitRow label="State">
        <ListItemText sx={{margin: 0}}>{ StateLabel[props.solution.state]?.toUpperCase() ?? String(props.solution.state).toUpperCase() } { SolutionState[props.solution.state] === SolutionState.resolved && <StateButton solution={props.solution} /> }</ListItemText>
      </SplitRow>

      { props.solution.target_at && <SplitRow label="Target date">
        <ListItemText sx={{margin: 0}}>{dayjs.unix(props.solution.target_at).format("ll")}</ListItemText>
      </SplitRow> }

      { props.solution.resolved_at && <SplitRow label="Resolved at">
        <ListItemText sx={{margin: 0}}>{dayjs.unix(props.solution.resolved_at).format("ll")}</ListItemText>
      </SplitRow> }

      { !usersSelectable ? <SplitRow label="Owner">
        <ListItemText sx={{margin: 0}}>{props.solution.owner?.display_name}</ListItemText>
      </SplitRow> : <SplitRow label="Owner">
        <UserAutocomplete
          options={users ?? []}
          value={props.solution.owner}
          placeholder="Add a responsible person"
          onChange={user => {
            let newParam = { owner: user?.id ?? null }
            props.onSave(newParam);
          }}
        />
      </SplitRow> }

      <Grid size={12}>
        <Actions {...props} />
      </Grid>
      </> }
    </Grid>
  </>
}

export default Toolbar;